import axios from "axios"
import http from "../index"
import {
  apiChangePassword,
  apiCreateRoleGroup,
  apiForgotPassword,
  apiGetCategoriesIncludeRoles,
  apiGetPersonalList,
  apiGetUserToRole,
  apiLogin,
  apiLogout,
  apiProfile,
  apiRegister,
  apiRegisterAccount,
  apiUpdateRoleGroup,
  apiVerifyCode,
} from "./urls"

const login = body => http.post(apiLogin, body)
const register = body => http.post(apiRegister, body)
const registerAccount = body => http.post(apiRegisterAccount, body)
const forgotPass = body => http.post(apiForgotPassword, body)
const verifyCode = body => http.post(apiVerifyCode, body)
const changePassword = body => http.post(apiChangePassword, body)
const logout = body => http.get(apiLogout, body)
const getCategoriesIncludeRoles = body =>
  http.get(apiGetCategoriesIncludeRoles, body)
const getUserToRole = body => http.get(apiGetUserToRole, body)
const createRoleGroup = body => http.post(apiCreateRoleGroup, body)
const updateRoleGroup = body => http.post(apiUpdateRoleGroup, body)
const getPersonalList = params => http.get(apiGetPersonalList, { params })
const getProfile = () => http.get(apiProfile, {})

//Lấy thông tin mã số thuế
const getInfoByTaxCode = code =>
  axios({
    method: "get",
    url: `https://api.vietqr.io/v2/business/${code}`,
    // data: { user }
  })

const AuthService = {
  login,
  logout,
  register,
  registerAccount,
  forgotPass,
  verifyCode,
  changePassword,
  getInfoByTaxCode,
  getCategoriesIncludeRoles,
  getUserToRole,
  createRoleGroup,
  updateRoleGroup,
  getPersonalList,
  getProfile,
}
export default AuthService



